import AnimatedLetters from '../AnimatedLetters';
import './index.scss'
import Loader from 'react-loaders';
import { useState, useEffect, useRef } from 'react';
import { publicKey, templateKey, serviceID } from '../../key';
import emailjs from '@emailjs/browser';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';


const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate');
  const refForm = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      serviceID, templateKey, refForm.current, publicKey
    ).then(
      () => { alert('Message successfully sent!')
      },
      () => { alert('Failed to send the message, please try again')
      }
    )
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);

    return () => {
      clearTimeout(timer);
    }  
  });

  return (
    <>
      <div className='container contact-page'>
        <div className='text-zone'>

          <h1>
            <AnimatedLetters 
            letterClass={letterClass}
            strArray={['C', 'o', 'n', 't', 'a', 'c', 't',' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am enthusiastically seeking entry-level software developer roles,
            particularly those that offer on-the-job learning. With a naturally
            curious disposition, I'm eager to immerse myself 
            in new challenges and acquire extensive knowledge in the field.
          </p>
          <div className='contact-form'>
            <form ref={refForm}>
              <ul>
                <li className='half'>
                  <input type='text' name='name' placeholder='Name' required/>
                </li>
                <li className='half'>
                  <input type='email' 
                  name='email'
                  placeholder='Email'
                  required/>
                </li>
                <li>
                  <input type='text' 
                  name='subject'
                  placeholder='Subject'
                  required/>
                </li>
                <li>
                  <textarea type='text' 
                  name='message'
                  placeholder='Message'
                  required
                  ></textarea>
                <li>
                <input type='submit' 
                onClick={sendEmail}
                className='flat-button'
                value='SEND'
                />
                </li>
                </li>
              </ul>
            </form>
            
          </div>
        </div>
        <div className='info-map'>
              Valeria Serci,
              <br />
              United Kingdom,
              <br />
              London, Kilburn
              <br />
              <br/>
              <span>valeria.serci.uk@gmail.com</span>
            </div>
            <div className='map-wrap'>
            <MapContainer center={[51.546499, -0.199831]} zoom={13} scrollWheelZoom={false}>

              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[51.546499, -0.199831]}>
                <Popup>
                  My location
                </Popup>
              </Marker>
            </MapContainer>
            </div>
      </div>
      <Loader type='pacman' />
    </>
  )
}

export default Contact;